import script from "./CircleToggleButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CircleToggleButton.vue?vue&type=script&setup=true&lang=js"

import "./CircleToggleButton.vue?vue&type=style&index=0&id=dc47449e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc47449e"]])

export default __exports__